module.exports = __webpack_public_path__ + "img/5.b4f1563d.jpg";